import { Card, Col, Row, Skeleton } from 'antd';
import type { FC } from 'react';

const DAY_COUNT = 7;

export const ScheduleCardsSkeleton: FC = () => {
  return (
    <Row gutter={16}>
      {Array.from({ length: DAY_COUNT }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
        <Col key={i} span={3}>
          <Card
            title={<Skeleton.Input active size="small" style={{ width: 100, height: 18 }} />}
            variant="outlined"
          >
            <Skeleton active paragraph={{ rows: 2 }} title={false} />
          </Card>
        </Col>
      ))}
    </Row>
  );
};
